<template>
  <div class="plv-ia-qn-new-preview">
    <div class="plv-ia-qn-new-preview-header" @click="showEditQuestionnaire">
      <div class="plv-ia-qn-new-preview-title">
        <p>{{ editingData.name }}</p>
      </div>
      <div class="plv-ia-qn-new-preview-introduce">
        <p>{{ editingData.desc }}</p>
      </div>
    </div>
    <!-- 问题列表-->
    <div class="plv-ia-qn-new-preview-contain">
      <div @click="showEditQuestionnaire">
        <QuestionPreview
          v-for="(item, index) in editingData.questions"
          :isFirstPreview.sync="isFirstPreview"
          :lang="lang"
          :questionData="item"
          :index="index + 1"
          :key="item.questionId"
          :is-full-preview="isFullPreview"
          @change-first-preview="saveFirstPreview"
          @move-up="(index) => handleMove(index, 'up')"
          @move-down="(index) => handleMove(index, 'down')"
          @delete-question="deleteQuestion"
        />
      </div>
    </div>
    <div v-if="isFirstPreview && !isFullPreview" class="plv-ia-qn-new-preview-modal">
      <div class="plv-ia-qn-new-preview-modal--opacity"></div>
    </div>
  </div>
</template>

<script>
import QuestionPreview from './QuestionPreview';
import { local } from '@polyv/utils/src/storage';
import Locale from '@/mixins/locale';
export default {
  name: 'QuestionnairePreview',
  components: {
    QuestionPreview
  },
  mixins: [Locale],
  props: {
    editingData: {
      type: Object,
      required: true
    },
    isFullPreview: {
      type: Boolean,
      default: false
    }
  },
  data() {
    const isFirstPreview = local.get('plvQAPreviewOver') !== 'Y';
    return {
      isFirstPreview,
    };
  },
  methods: {
    showEditQuestionnaire() {
      if (this.isFullPreview) return;
      this.$emit('show-edit-questionnaire');
    },
    saveFirstPreview(val) {
      this.isFirstPreview = val;
      local.set('plvQAPreviewOver', 'Y');
    },
    handleMove(index, type) {
      if (type === 'up' && index > 0) {
        const questions = this.editingData.questions;
        const temp = questions[index];
        questions[index] = questions.splice(index - 1, 1, temp)[0];
      } else if (type === 'down' && index < this.editingData.questions.length - 1) {
        const questions = this.editingData.questions;
        const temp = questions[index];
        questions[index] = questions.splice(index + 1, 1, temp)[0];
      }
    },
    deleteQuestion(index) {
      const questions = this.editingData.questions;
      questions.splice(index, 1);
    }
  }
};
</script>

<style lang="scss">
.plv-ia-qn-new-preview-modal {
  background: rgba(#000000, 0.3);
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1;
  .plv-ia-qn-new-preview-modal--opacity {
    position: absolute;
    top: 0;
    height: 100px;
    opacity: 0;
  }
}
.plv-ia-qn-new-preview {
  height: 100%;
  flex: 1;
  padding: 0 16px 16px 16px;
  overflow: auto;
  box-sizing: border-box;
}
.plv-ia-qn-new-preview-title {
  font-size: 18px;
  color: #333333;
  font-weight: bold;
  text-align: center;
  word-break: break-all;
}
.plv-ia-qn-new-preview-introduce {
  font-size: 14px;
  color: #666666;
  line-height: 20px;
  word-break: break-word;
  margin-top: 10px;
  text-align: center;
}
.plv-ia-qn-new-preview-contain {
  position: relative;
}
.plv-ia-qn-new-preview-header {
  padding: 16px 0 20px 0;
  cursor: pointer;
}
.plv-ia-qn-new-preview-header:hover {
  background-color: #F6F6F6;
}
</style>
